//src/store/commonSlices/uiDraftsSlice.js
import { createSlice } from '@reduxjs/toolkit';


const initialState = { drafts: {} };


const uiDraftsSlice = createSlice({
name: 'uiDrafts',
initialState,
reducers: {
saveDraft(state, action) {
const { key, data } = action.payload;
      state.drafts[key] = {
        data,
        timestamp: Date.now(), // ⏱️ add metadata
      };
},
clearDraft(state, action) {
const key = action.payload;
delete state.drafts[key];
},
},
});


export const { saveDraft, clearDraft } = uiDraftsSlice.actions;
export default uiDraftsSlice.reducer;